<script lang="ts" setup>
import MainFooter from '@/components/MainFooter.vue';
</script>

<template>
  <div :class="css.layout">
    <slot />
    <MainFooter />
  </div>
</template>

<style lang="scss" module="css">
.layout {
  background: linear-gradient(135deg, $color-doctor-100 0%, $color-white 100%);
  min-height: 100dvh;
  width: 100%;
  display: flex;
  margin-top: -$main-header-height;
  flex-direction: column;
}
</style>
